// ============================================================================
// @alloyhead/core — Type Definitions & ABI Constants
// ============================================================================
export const ABI_VERSION = 2;
// --- Engine Return Codes ---
export const EngineStatus = {
    OK: 0,
    IN_PROGRESS: 1,
    SCHEMA_MISMATCH: 2,
    OUT_OF_MEMORY: 3,
    FATAL: -1,
};
export const AbortStatus = { OK: 0, NOOP: 1 };
// --- Buffer Format Enum ---
export const BufferFormat = {
    RGBA8: 0,
    RGBA16F: 1,
    RGBA32F: 2,
    R8: 3,
    R32F: 4,
    AUDIO_F32: 5,
};
export const BUFFER_FORMAT_BPP = {
    0: 4, 1: 8, 2: 16, 3: 1, 4: 4, 5: 4,
};
// --- Buffer Flags ---
export const BufferFlags = {
    DIRTY: 1 << 0,
    READ_ONLY: 1 << 1,
    COMPOSITE: 1 << 2,
    SCRATCH: 1 << 3,
};
// --- Memory Layout Constants ---
export const ERROR_REGION_SIZE = 256;
export const ERROR_CODE_OFFSET = 0;
export const ERROR_LENGTH_OFFSET = 4;
export const ERROR_MESSAGE_OFFSET = 8;
export const MAX_ERROR_MESSAGE_LENGTH = 248;
export const DESCRIPTOR_TABLE_HEADER_SIZE = 8;
export const BUFFER_ENTRY_SIZE = 32;
export const RING_HEADER_SIZE = 12;
export const COMMAND_SLOT_SIZE = 32;
export const PERF_REGION_SIZE = 32;
export const DEFAULT_CONFIG = {
    targetFps: 120,
    maxAsyncTicks: 600,
    ringBufferCapacity: 256,
    commandSlotSize: COMMAND_SLOT_SIZE,
    paramBufferSize: 1024,
    enablePerfOverlay: false,
    statsReportIntervalMs: 100,
    workerInitTimeoutMs: 10_000,
};
//# sourceMappingURL=types.js.map